<template>
    <router-view></router-view>
</template>

<script>

export default {
    name: "OutletPosts",
};
</script>

<style scoped></style>
